

export const searchServer = async (functionParameters = {}) =>{
    
    const isEmpty = (await import(/* webpackPrefetch: true */ `../../../classes/universal_methods/isEmpty`)).isEmpty;

    const apiEndPoint = window.apiEndPoint;
    const language = window.userLanguage;
    const sideMenuItems = window.currentSideMenuItems;
    const app = window.smetioApp;
    
    console.log("You are about to search for treatment and functionParameters is ", functionParameters);
    const {searchWord} = functionParameters;
    let {sideMenuToUse} = functionParameters;

    if(isEmpty(searchWord)){

        if("searchWord" in app.filters[sideMenuToUse] ) delete app.filters[sideMenuToUse]["searchWord"];

        return sideMenuItems[sideMenuToUse].onClick();
    };

    app.filters[sideMenuToUse]["searchWord"] = searchWord;

    app.getTotalNumberOfAvailableData(sideMenuToUse);


};
